// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__a5-Br","overlay":"styles_overlay__2gsC7"};